import { DatePicker, Input, Select, Text, HStack, VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import { Box, Checkbox } from 'native-base';
import React, { useMemo } from 'react';

import {
  AssetSelectedTypeMap,
  ClubsDetailsEntityNormalized,
} from '../../../../../../../../../../store/product/types';
import {
  ClubsAssetController,
  ClubsDetailsController,
} from '../../../../../../../../../BatchTicket/components/DynamicAsset/hooks/products/Clubs';
import { ProductCard } from '../../../../components/ProductCard';

interface ClubsDetailsCardProps {
  offer: AssetSelectedTypeMap['clubs'];
  detailsController: ClubsDetailsController;
  details: ClubsDetailsEntityNormalized | null | undefined;
  offerController: ClubsAssetController;
}

export const ClubsDetailsCard: React.FC<ClubsDetailsCardProps> = ({
  offer,
  details,
  detailsController,
  offerController,
}) => {
  const detailItems = useMemo(
    () => [
      {
        label: 'Produto',
        value: details?.clubNameNormalized,
      },
      {
        label: 'Liquidação',
        value: details?.settlementDateNormalized,
      },
      {
        label: 'Valor investido',
        value: offerController.currentValueFormatted,
      },
    ],
    [details, offerController.currentValueFormatted]
  );

  const {
    selectedDate,
    handleSetDate,
    handleClearDate,
    handleSetObservation,
    isAgreementChecked,
    handleSetAgreement,
    channelOptions,
    selectedChannel,
    handleSetSelectedChannel,
  } = detailsController;

  return (
    <VStack space="stack.nano" zIndex={1}>
      <ProductCard
        title={offer.managerNameNormalized}
        infos={detailItems}
        productColor="product.clubes"
        zIndex={1}
        BottomComponent={
          <VStack space="stack.xxs">
            <HStack
              justifyContent="space-between"
              space="stack.quarck"
              zIndex={1}
              padding="inset.xs"
              backgroundColor={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.3)}
              borderRadius="xs">
              <Text>Valor total da boleta</Text>
              <Text variant="semibold" textAlign="right">
                {Utils.Mask.Money(offerController.currentValue)}
              </Text>
            </HStack>
            <VStack space="stack.quarck" zIndex={3}>
              <Text color="neutral.black" variant="semibold">
                Data para agendamento
              </Text>
              <DatePicker
                onClear={handleClearDate}
                onSelectDate={handleSetDate}
                date={selectedDate}
                availableRange={{ past: new Date() }}
              />
            </VStack>
            <VStack space="stack.quarck" zIndex={1}>
              <Text color="neutral.black" variant="semibold">
                Selecione o canal
              </Text>
              <Select
                placeholder="Selecione"
                options={channelOptions}
                onValueChange={handleSetSelectedChannel}
                selectedValue={selectedChannel}
              />
            </VStack>
            <VStack space="stack.quarck">
              <Text color="neutral.black" variant="semibold">
                Observação
              </Text>
              <Input
                variant="filled"
                autoComplete="off"
                name="scheduleDate"
                onBlur={handleSetObservation}
              />
            </VStack>
          </VStack>
        }
      />
      <Box
        padding="inset.nano"
        borderRadius="sm"
        backgroundColor={Utils.ColorToken.WithOpacity('feedback.attention.lightest', 0.6)}>
        <HStack alignItems="center" width="100%" space="stack.nano">
          <Checkbox onChange={handleSetAgreement} value="1" isChecked={isAgreementChecked} />
          <Text flex={1}>
            <Text variant="bold">Atenção:</Text> Declaro que a solicitação de aplicação foi
            autorizada pelo cliente, de forma prévia á realização desta operação, e que a mesma foi
            recebida por canal autorizado e gravado
          </Text>
        </HStack>
      </Box>
    </VStack>
  );
};
